import{d as e,T as m}from"./defaultTheme-7eb11447.js";import{u as r}from"./useThemeProps-db18733d.js";function s({props:s,name:o}){return r({props:s,name:o,defaultTheme:e,themeId:m})}export{s as u};
